import { swingbotApi } from '../../util/api';
/**
 * createLicenseeKey
 * @param {int} licenseeId the id of the licensee creating the key
 */
export const createApiKey = (licenseeId) => {
    return swingbotApi(`licensee/${licenseeId}/api-key`, { licenseeId }, 'post', true, 'licensee')
        .then(response => response)
        .catch(err => Promise.reject(err));
};